import { Sparkles } from 'lucide-react'
import * as m from '~/paraglide/messages'
import { Button } from '~/shared/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '~/shared/ui/dialog'

interface UpgradeSuccessDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  tier: string
}

export function UpgradeSuccessDialog({ open, onOpenChange, tier }: UpgradeSuccessDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-orange-500" />
            {m.upgradeSuccessTitle()}
          </DialogTitle>
          <DialogDescription>{m.upgradeSuccessDescription({ tier })}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>{m.close()}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
